import auth from './auth';
import entities from './entities';
import ui from './ui';

export default {
  auth,
  entities,
  ui,
};
